import {
    COMPUTED_WHATSAPP_VARIABLE_KEYS,
    WHATSAPP_TEMPLATE_BLOCK_REASONS,
    WHATSAPP_TEMPLATE_PARAMETER_KINDS,
    WHATSAPP_TEMPLATE_VARIABLE_SOURCES,
} from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { schemaWhatsAppTemplateButton } from 'cpool-schemas';
import { z } from 'zod';

const schemaTemplateVariableSource = z.discriminatedUnion('source', [
    z.object({
        field: z.enum(['firstName', 'lastName', 'email', 'phone', 'title', 'salutation']),
        source: z.literal(WHATSAPP_TEMPLATE_VARIABLE_SOURCES.AGENT),
    }),
    z.object({
        field: z.enum(['firstName', 'lastName', 'salutation']),
        source: z.literal(WHATSAPP_TEMPLATE_VARIABLE_SOURCES.APPLICANT),
    }),
    z.object({
        field: z.enum(['firstName', 'lastName', 'email']),
        source: z.literal(WHATSAPP_TEMPLATE_VARIABLE_SOURCES.PARTNER),
    }),
    z.object({
        key: z.nativeEnum(COMPUTED_WHATSAPP_VARIABLE_KEYS),
        source: z.literal(WHATSAPP_TEMPLATE_VARIABLE_SOURCES.COMPUTED),
    }),
    z.object({ source: z.literal(WHATSAPP_TEMPLATE_VARIABLE_SOURCES.CUSTOM) }),
]);

const schemaApprovedWhatsAppTemplateParameters = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal(WHATSAPP_TEMPLATE_PARAMETER_KINDS.NONE) }),
    z.object({
        count: z.number().int().nonnegative(),
        kind: z.literal(WHATSAPP_TEMPLATE_PARAMETER_KINDS.POSITIONAL),
    }),
    z.object({
        kind: z.literal(WHATSAPP_TEMPLATE_PARAMETER_KINDS.NAMED),
        variables: z.record(z.string(), schemaTemplateVariableSource),
    }),
]);

export const schemaWabaResolver_GetWhatsAppTemplatesItem = z.object({
    blockReasonCode: z.nativeEnum(WHATSAPP_TEMPLATE_BLOCK_REASONS).optional(),
    body: z.record(z.string(), z.string()),
    buttons: z.record(z.string(), z.array(schemaWhatsAppTemplateButton)).optional(),
    displayName: z.string().min(1),
    folder: z.string().min(1),
    header: z.record(z.string(), z.string()).optional(),
    // Separate slot from `parameters`: a POSITIONAL header's {{1}} is not the body's {{1}}.
    headerParameters: schemaApprovedWhatsAppTemplateParameters.optional(),
    languages: z.array(z.string().min(1)),
    parameters: schemaApprovedWhatsAppTemplateParameters,
    sendable: z.boolean(),
    syncedAt: z.string().min(1).optional(),
    templateName: z.string().min(1),
    unknownVariableNames: z.array(z.string()).optional(),
});

export const schemaWabaResolver_GetWhatsAppTemplates = z.array(schemaWabaResolver_GetWhatsAppTemplatesItem);

export type SchemaWabaResolver_GetWhatsAppTemplates = z.infer<typeof schemaWabaResolver_GetWhatsAppTemplates>;
export type SchemaWabaResolver_GetWhatsAppTemplatesItem = z.infer<typeof schemaWabaResolver_GetWhatsAppTemplatesItem>;

type Arguments = Record<string, never>;

export type WabaResolver_GetWhatsAppTemplates = Resolver<Arguments, SchemaWabaResolver_GetWhatsAppTemplates>;
